import React, { useEffect, useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import FilterTable from '../../../components/FilterTable'
import GetDealWiseInvestor from '../../../APIs/InvestorPortfolio/GetDealWiseInvestor'
import { Link } from 'react-router-dom'
import Loader from '../../../components/Loader'
import GetOwnerPortfolio from '../../../APIs/OwnerPortfolio/GetOwnerPortfolio'
import GetInvestorPortfolio from '../../../APIs/InvestorPortfolio/GetInvestorPortfolio'
import GetProject from '../../../APIs/Project/GetProject'
import GetInvestorTransactionsfilter from '../../../APIs/InvestorPortfolio/GetInvestorTransactionsfilter'

const InvestorPortfolioNew = () => {
    const [ownerTempList, setOwnerTempList] = useState([])
    const [ownerList, setOwnerList] = useState([])
    const [investorTempList, setInvestorTempList] = useState([])
    const [investorList, setInvestorList] = useState([])
    const [dealwiseownerTempList, setDealWiseownerTempList] = useState([])
    const [dealwiseownerList, setDealWiseownerList] = useState([])
    const [isProject, setIsProject] = useState(0);
    const [activeTab, setActiveTab] = useState("request");
    const [investorId, setinvestorId] = useState();
    const [fromdate, setFromDate] = useState();
    const [todate, settoDate] = useState();

    let [loader, setLoader] = useState(1);
    let [projects, setProjects] = useState([])
    let [projectId, setselectedProjects] = useState(null)


    const getdata = async () => {
        setLoader(1)
        let transstatus = null
        if (activeTab === "request") {
            transstatus=6
        }
        else if (activeTab === "inprocess") {
            transstatus=2
        }
        else if (activeTab === "completed") {
            transstatus=3
        }
        else if (activeTab === "failed") {
            transstatus=4
        }
        
        console.log(projectId,fromdate,todate)
        const response = await GetInvestorTransactionsfilter({projectId,investorId,fromdate,todate,transstatus})
        if (response.status === 1) {
            setLoader(0)
            setOwnerTempList(response.responseValue)
            setOwnerList(response.responseValue)
        }
        else {
            setOwnerTempList([])
            setOwnerList([])
            setLoader(0)
        }
    }
    const getInvestorPortfolio = async () => {
        setLoader(1)
        const response = await GetInvestorPortfolio()
        if (response.status === 1) {
            setLoader(0)
            setInvestorTempList(response.responseValue)
            setInvestorList(response.responseValue)
        }
        else {
            setInvestorTempList([])
            setInvestorList([])
            setLoader(0)
        }
    }
    const getDealWiseInvestor = async () => {
        const response = await GetDealWiseInvestor()
        if (response.status === 1) {
            setDealWiseownerTempList(response.responseValue)
            setDealWiseownerList(response.responseValue)
        }
        else {
            setDealWiseownerTempList([])
            setDealWiseownerList([])
        }
    }
    const getallprojects = async () => {
        try {
            let allProjects = await GetProject();
            if (allProjects.status === 1) {
                setProjects(allProjects.responseValue.reverse());
                setLoader(0);
            } else {
                setLoader(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoader(0);
        }
    }
    useEffect(() => {
        getallprojects();
    }, [])
        useEffect(() => {
        getdata();
    }, [activeTab,projectId,todate,fromdate])


    return (
        <>
            <div className='container-fluid landformconatiner p-4'>
                <div className='d-flex flex-column flex-md-row justify-content-between'>
                    <PageHeading pagename="Investor Transaction Details" />
                    <div className="iovtpdiv">
                        <div className="">
                            <select className='form-select' onChange={(e)=>{setselectedProjects(e.target.value)}} >
                                <option value={0}>Projects</option>
                                {projects && projects.map((val, ind) => {
                                    return (
                                        <option value={val.id} key={val.id}>{val.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <FilterTable tempList={isProject === 0 ? ownerTempList : dealwiseownerTempList} tempListMethod={isProject === 0 ? setOwnerTempList : setDealWiseownerTempList} originalList={isProject === 0 ? ownerList : dealwiseownerList} isdaterange={true} settoDate={settoDate}setFromDate={setFromDate}/>
                    </div>

                </div>
                <div className="mt-3">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "request" ? "active" : ""}`}
                                onClick={() => setActiveTab("request")}
                            >
                                Request
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "inprocess" ? "active" : ""}`}
                                onClick={() => setActiveTab("inprocess")}
                            >
                                In Process
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "completed" ? "active" : ""}`}
                                onClick={() => setActiveTab("completed")}
                            >
                                Completed
                            </button>
                        </li>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === "failed" ? "active" : ""}`}
                                onClick={() => setActiveTab("failed")}
                            >
                                Failed
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="pt-4">
                    {activeTab === "request" && (
                        <table className="table">
                            <thead>
                                <tr className='table-head'>
                                    <th scope="col">Name</th>
                                    <th scope="col">In Project</th>
                                    <th scope="col">Land Area</th>
                                    <th scope="col">Given Amount</th>
                                    <th scope="col">Total Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                {
                                    ownerTempList && ownerTempList.map((val, ind) => {
                                        return (
                                            <tr key={ind}>
                                                <td>
                                                    <div className='d-flex flex-row gap-2'>
                                                        <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                        <span className='d-flex flex-column gap-1'>
                                                            <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{val.projectName}</td>
                                                <td>{val.landArea} {val.unitName}</td>
                                                <td>{val.givenAmount}</td>
                                                <td>{val.investedAmount}</td>
                                                <td >
                                                    <div class="dropdown dropend">
                                                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                        <ul className="dropdown-menu mr-3">
                                                            <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.investorName}/${val.paidToId}/1/0/${val.projectName}/${false}`}>View Transaction</Link></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    )}

                    {activeTab === "inprocess" && (
                         <table className="table">
                            <thead>
                                <tr className='table-head'>
                                    <th scope="col">Name</th>
                                    <th scope="col">In Project</th>
                                    <th scope="col">Land Area</th>
                                    <th scope="col">Given Amount</th>
                                    <th scope="col">Total Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                {
                                    ownerTempList && ownerTempList.map((val, ind) => {
                                        return (
                                            <tr key={ind}>
                                                <td>
                                                    <div className='d-flex flex-row gap-2'>
                                                        <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                        <span className='d-flex flex-column gap-1'>
                                                            <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{val.projectName}</td>
                                                <td>{val.landArea} {val.unitName}</td>
                                                <td>{val.givenAmount}</td>
                                                <td>{val.amountTobePaid}</td>
                                                <td >
                                                    <div class="dropdown dropend">
                                                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                        <ul className="dropdown-menu mr-3">
                                                            <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.investorName}/${val.paidToId}/1/0/${val.projectName}/${false}`}>View Transaction</Link></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    )}

                    {activeTab === "completed" && (
                         <table className="table">
                            <thead>
                                <tr className='table-head'>
                                    <th scope="col">Name</th>
                                    <th scope="col">In Project</th>
                                    <th scope="col">Land Area</th>
                                    <th scope="col">Given Amount</th>
                                    <th scope="col">Total Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                {
                                    ownerTempList && ownerTempList.map((val, ind) => {
                                        return (
                                            <tr key={ind}>
                                                <td>
                                                    <div className='d-flex flex-row gap-2'>
                                                        <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                        <span className='d-flex flex-column gap-1'>
                                                            <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{val.projectName}</td>
                                                <td>{val.landArea} {val.unitName}</td>
                                                <td>{val.givenAmount}</td>
                                                <td>{val.amountTobePaid}</td>
                                                <td >
                                                    <div class="dropdown dropend">
                                                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                        <ul className="dropdown-menu mr-3">
                                                            <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.investorName}/${val.paidToId}/1/0/${val.projectName}/${false}`}>View Transaction</Link></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    )}

                    {activeTab === "failed" && (
                         <table className="table">
                            <thead>
                                <tr className='table-head'>
                                    <th scope="col">Name</th>
                                    <th scope="col">In Project</th>
                                    <th scope="col">Land Area</th>
                                    <th scope="col">Given Amount</th>
                                    <th scope="col">Total Amount</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody className='table-body'>
                                {
                                    ownerTempList && ownerTempList.map((val, ind) => {
                                        return (
                                            <tr key={ind}>
                                                <td>
                                                    <div className='d-flex flex-row gap-2'>
                                                        <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                        <span className='d-flex flex-column gap-1'>
                                                            <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>{val.projectName}</td>
                                                <td>{val.landArea} {val.unitName}</td>
                                                <td>{val.givenAmount}</td>
                                                <td>{val.amountTobePaid}</td>
                                                <td >
                                                    <div class="dropdown dropend">
                                                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                        <ul className="dropdown-menu mr-3">
                                                            <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.investorName}/${val.paidToId}/1/0/${val.projectName}/${false}`}>View Transaction</Link></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    )}
                </div>

                {/* <div className='pt-4'>
                    <table className="table">
                        <thead>
                            <tr className='table-head'>
                                <th scope="col">Name</th>
                                <th scope="col">In Project</th>
                                <th scope="col">Land Area</th>
                                <th scope="col">Given Amount</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {
                                ownerTempList && ownerTempList.map((val, ind) => {
                                    return (
                                        <tr key={ind}>
                                            <td>
                                                <div className='d-flex flex-row gap-2'>
                                                    <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                    <span className='d-flex flex-column gap-1'>
                                                        <label className='heading-project fw-semibold'>{val.investorName}</label>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{val.projectName}</td>
                                            <td>{val.landArea} {val.unitName}</td>
                                            <td>{val.givenAmount}</td>
                                            <td>{val.investedAmount}</td>
                                            <td >
                                                <div class="dropdown dropend">
                                                    <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                    <ul className="dropdown-menu mr-3">
                                                        <li><Link className="dropdown-item" to={`/investorportfoliooverview/Project/${val.payeeType}/${val.referenceId}/${val.investorName}/${val.paidToId}/1/0/${val.projectName}`}>View Transaction</Link></li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div> : */}

            </div>
            <Loader show={loader} />

        </>
    )
}

export default InvestorPortfolioNew;
